import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

const SvgChevronDownDouble = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m7 13 5 5 5-5M7 6l5 5 5-5"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgChevronDownDouble)
export default ForwardRef
